/* IDCoco · loja · v6 · página de curiosidades */
(function(){
"use strict";
var $ = function(s, r){ return (r || document).querySelector(s); };
var $$ = function(s, r){ return [].slice.call((r || document).querySelectorAll(s)); };
function num(v, casas){ return v.toFixed(casas || 0).replace(".", ","); }

/* ---------- o coco por dentro ---------- */
var coco = $("#cuCoco"), camadas = $$(".cu-camada"), partes = $$(".cu-parte"), abas = $$(".cu-partes [data-parte]"), pontos = $$(".cu-ponto"), dica = $("[data-dica]");
function abrirParte(id, inicial){
  partes.forEach(function(p){ p.hidden = p.dataset.parte !== id; });
  abas.forEach(function(a){ a.setAttribute("aria-selected", a.dataset.parte === id ? "true" : "false"); });
  pontos.forEach(function(p){ p.classList.toggle("ativo", p.dataset.parte === id); });
  camadas.forEach(function(c){ c.classList.toggle("ativa", c.dataset.parte === id); });
  if (coco && !inicial) coco.classList.add("foco");
  if (dica) dica.hidden = true;
}
abas.concat(pontos, camadas).forEach(function(b){ b.addEventListener("click", function(){ abrirParte(b.dataset.parte); }); });
abrirParte("agua", true); // abre na água, que é de onde sai o sachê

/* ---------- mito ou verdade ---------- */
var FRASES = [
  { f:__t("idcoco.coco_verde_e_coco_seco_sao_html", "Coco verde e coco seco são frutas diferentes."), r:"mito",
    e:__t("jogos_e_calculadoras.e_o_mesmo_fruto_em_idades_html", "É o mesmo fruto em idades diferentes. O verde é colhido por volta dos 6 a 7 meses, quando está cheio de água. Se fica no pé, vira coco seco.") },
  { f:__t("jogos_e_calculadoras.botanicamente_o_coco_nao_e_uma_html", "Botanicamente, o coco não é uma noz."), r:"verdade",
    e:__t("jogos_e_calculadoras.para_a_botanica_o_coco_e_html", "Para a botânica, o coco é uma drupa, o mesmo tipo de fruto do pêssego e da azeitona: casca, polpa e um caroço duro no meio.") },
  { f:__t("idcoco.um_coco_consegue_atravessar_o_mar_html", "Um coco consegue atravessar o mar e brotar em outra praia."), r:"verdade",
    e:__t("jogos_e_calculadoras.a_fibra_funciona_como_boia_e_html", "A fibra funciona como boia e protege a semente da água salgada. Foi boiando que o coqueiro se espalhou por praias tropicais do mundo todo.") },
  { f:__t("idcoco.o_sache_fechado_precisa_ficar_na_html", "O sachê fechado precisa ficar na geladeira."), r:"mito",
    e:__t("jogos_e_calculadoras.fechado_ele_dura_12_meses_em_html", "Fechado, ele dura 12 meses em temperatura ambiente, em local seco e longe do calor. Geladeira só faz diferença na água que você vai usar para diluir.") },
  { f:__t("jogos_e_calculadoras.da_para_tomar_o_concentrado_puro_html", "Dá para tomar o concentrado puro, direto do sachê."), r:"mito",
    e:__t("jogos_e_calculadoras.o_concentrado_foi_feito_para_diluir_html", "O concentrado foi feito para diluir. O jeito certo é colocar o IDCoco primeiro no copo ou na garrafa e completar com até 500 ml de água mineral antes de beber.") },
  { f:__t("jogos_e_calculadoras.agua_de_coco_ajuda_a_repor_html", "Água de coco ajuda a repor eletrólitos."), r:"verdade",
    e:__t("jogos_e_calculadoras.ela_tem_minerais_como_o_potassio_html", "Ela tem minerais como o potássio e o sódio, que o corpo perde no suor. Por isso é tão pedida depois de treino e de dia de praia.") },
  { f:__t("jogos_e_calculadoras.a_casca_do_coco_verde_nao_html", "A casca do coco verde não tem aproveitamento."), r:"mito",
    e:__t("jogos_e_calculadoras.na_idcoco_100_da_casca_e_html", "Na IDCoco, 100% da casca é aproveitada: vira briquete de energia no lugar de carvão e lenha, e a fibra e o pó vão para a agricultura.") }
];
var quiz = $("#quiz");
if (quiz){
  var i = 0, acertos = 0, ordem = [];
  var frase = $("#quizFrase"), conta = $("#quizConta"), barra = $("#quizBarra"), cartao = $("#quizCartao"),
      resp = $("#quizResposta"), veredito = $("#quizVeredito"), explica = $("#quizExplica"), proxima = $("#quizProxima"),
      fim = $("#quizFim"), botoes = $$("[data-resposta]", quiz);
  function comecar(){
    ordem = FRASES.map(function(_, k){ return k; }).sort(function(){ return Math.random() - .5; });
    i = 0; acertos = 0; fim.hidden = true; cartao.hidden = false; mostrar();
  }
  function mostrar(){
    var q = FRASES[ordem[i]];
    frase.textContent = "“" + q.f + "”";
    conta.textContent = (i + 1) + " de " + FRASES.length;
    barra.style.width = (i / FRASES.length * 100) + "%";
    resp.hidden = true;
    cartao.classList.remove("certo", "errado");
    botoes.forEach(function(b){ b.disabled = false; b.classList.remove("escolhido"); });
  }
  botoes.forEach(function(b){
    b.addEventListener("click", function(){
      var q = FRASES[ordem[i]], certo = b.dataset.resposta === q.r;
      if (certo) acertos++;
      botoes.forEach(function(x){ x.disabled = true; });
      b.classList.add("escolhido");
      cartao.classList.add(certo ? "certo" : "errado");
      veredito.textContent = (certo ? __t("jogos_e_calculadoras.acertou_html", "Acertou. ") : __t("jogos_e_calculadoras.nao_foi_dessa_vez_html", "Não foi dessa vez. ")) + ({ mito:__t("idcoco.e_mito_html", "É mito."), verdade:__t("idcoco.e_verdade_html", "É verdade.") })[q.r];
      explica.textContent = q.e;
      proxima.textContent = i === FRASES.length - 1 ? __t("jogos_e_calculadoras.ver_resultado_html", "Ver resultado") : __t("curiosidades.proxima_html", "Próxima");
      resp.hidden = false;
      barra.style.width = ((i + 1) / FRASES.length * 100) + "%";
      proxima.focus();
    });
  });
  proxima.addEventListener("click", function(){
    i++;
    if (i < FRASES.length){ mostrar(); botoes[0].focus(); return; }
    cartao.hidden = true; fim.hidden = false;
    conta.textContent = __t("jogos_e_calculadoras.resultado_html", "Resultado");
    $("#quizPlacar").textContent = acertos + "/" + FRASES.length;
    $("#quizFimTexto").textContent = acertos === FRASES.length ? __t("jogos_e_calculadoras.gabaritou_voce_entende_de_coco_html", "Gabaritou! Você entende de coco.")
      : acertos >= 5 ? __t("jogos_e_calculadoras.mandou_bem_quase_um_especialista_em_html", "Mandou bem! Quase um especialista em coco.")
      : acertos >= 3 ? __t("jogos_e_calculadoras.nada_mal_agora_voce_ja_sabe_html", "Nada mal! Agora você já sabe o resto.")
      : __t("jogos_e_calculadoras.agora_voce_sabe_mais_de_coco_html", "Agora você sabe mais de coco do que quando começou!");
    $("#quizDeNovo").focus();
  });
  $("#quizDeNovo").addEventListener("click", comecar);
  comecar();
}

/* ---------- diluição: menos água, cor mais forte e texto de sabor ---------- */
var agua = $("#agua");
if (agua){
  var liquido = $("#copoLiquido"), brilho = $("#copoBrilho"), aguaValor = $("#aguaValor"), aguaTexto = $("#aguaTexto");
  var CLARO = [233, 238, 207], FORTE = [205, 214, 158];
  /* desempenho (05/10): no automático isto roda a cada quadro. O nível do líquido anda por transform (sem layout; o
     "y" do retângulo fica fixo no copo cheio) e cor, número, texto e trilho só são escritos quando mudam */
  var TOPO = 60, ult = {};
  liquido.setAttribute("y", TOPO); brilho.setAttribute("y", TOPO);
  function poe(chave, v, f){ if (ult[chave] !== v){ ult[chave] = v; f(v); } }
  function diluir(){
    var ml = Math.round(+agua.value), t = (500 - ml) / 250; // 0 no mais suave, 1 no mais doce
    var y = 296 - (ml / 500) * 236;             // o copo cheio chega a 60 no desenho
    poe("y", "translateY(" + (y - TOPO) + "px)", function(v){ liquido.style.transform = v; brilho.style.transform = v; });
    poe("cor", "rgb(" + CLARO.map(function(c, k){ return Math.round(c + (FORTE[k] - c) * t); }).join(",") + ")", function(v){ liquido.setAttribute("fill", v); });
    poe("ml", Math.round(ml / 5) * 5 + " ml", function(v){ aguaValor.textContent = v; });
    poe("faixa", ml >= 475 ? 0 : ml >= 375 ? 1 : 2, function(v){
      aguaTexto.innerHTML = v === 0 ? __t("jogos_e_calculadoras.do_jeito_do_rotulo_leve_e_html", "<b>Do jeito do rótulo.</b> Leve e refrescante, como água de coco tirada do coco.")
        : v === 1 ? __t("jogos_e_calculadoras.um_pouco_mais_doce_bom_ponto_html", "<b>Um pouco mais doce.</b> Bom ponto para quem gosta de sentir mais o coco.")
        : __t("jogos_e_calculadoras.bem_mais_doce_e_encorpada_para_html", "<b>Bem mais doce e encorpada.</b> Para quem quer o coco em primeiro plano.");
    });
    poe("p", ((ml - 250) / 250 * 100) + "%", function(v){ agua.style.setProperty("--p", v); });
  }
  agua.addEventListener("input", diluir);
  diluir();

  /* sozinho, como um gif: 2,5 s de 500 até 250 ml e 2,5 s de volta, sem parar.
     Pausa enquanto a pessoa mexe e volta 4 s depois; só roda com a seção na tela. */
  var IDA = 2500, autoT0 = null, autoRaf = 0, autoVisivel = false, autoEspera = 0, autoMexendo = false, autoUlt = 0;
  function autoPasso(agora){
    if (autoT0 === null) autoT0 = agora - IDA * (500 - agua.value) / 250; // continua de onde o pino está
    // 30 quadros por segundo bastam para um nível que leva 2,5 s para descer, e custam metade (05/10)
    if (agora - autoUlt < 30){ autoRaf = requestAnimationFrame(autoPasso); return; }
    autoUlt = agora;
    var f = ((agora - autoT0) % (2 * IDA)) / IDA, p = f < 1 ? f : 2 - f;
    agua.value = 500 - 250 * (1 - Math.cos(Math.PI * p)) / 2;
    diluir();
    autoRaf = requestAnimationFrame(autoPasso);
  }
  function autoLiga(){
    if (autoRaf || !autoVisivel || autoMexendo) return;
    agua.step = "any"; autoT0 = null; liquido.parentNode.classList.add("auto");
    autoRaf = requestAnimationFrame(autoPasso);
  }
  function autoDesliga(){
    cancelAnimationFrame(autoRaf); autoRaf = 0; liquido.parentNode.classList.remove("auto");
    agua.step = 25; agua.value = Math.round(agua.value / 25) * 25; diluir();
  }
  function autoPausa(){
    autoMexendo = true; clearTimeout(autoEspera);
    if (autoRaf) autoDesliga();
  }
  function autoRetoma(){
    clearTimeout(autoEspera);
    autoEspera = setTimeout(function(){ autoMexendo = false; autoLiga(); }, 4000);
  }
  if (!matchMedia("(prefers-reduced-motion: reduce)").matches && "IntersectionObserver" in window){
    ["pointerdown", "focus", "keydown"].forEach(function(ev){ agua.addEventListener(ev, autoPausa); });
    ["pointerup", "pointercancel", "blur"].forEach(function(ev){ agua.addEventListener(ev, autoRetoma); });
    agua.addEventListener("keyup", autoRetoma);
    new IntersectionObserver(function(es){
      autoVisivel = es[0].isIntersecting;
      if (autoVisivel) autoLiga(); else if (autoRaf){ cancelAnimationFrame(autoRaf); autoRaf = 0; }
    }, {threshold: .25}).observe(agua.closest("section") || agua);
  }
}

/* ---------- quanto pesa levar coco ---------- */
var litros = $("#litros");
if (litros){
  function carregar(){
    var l = +litros.value, saches = l * 2;
    var coco = l * 3, caixinha = l * 1.04;
    $("#litrosValor").textContent = l + (l === 1 ? __t("jogos_e_calculadoras.litro_html", " litro") : __t("jogos_e_calculadoras.litros_html", " litros"));
    $("#pesoCoco").textContent = num(coco, coco < 10 ? 1 : 0) + " kg";
    $("#pesoCaixinha").textContent = num(caixinha, caixinha < 10 ? 1 : 0) + " kg";
    $("#qtdSache").textContent = saches + __t("jogos_e_calculadoras.saches_html", " sachês");
    $("#sacheNota").textContent = __t("jogos_e_calculadoras.sao_html", "São ") + num(saches * 37 / 1000, 2).replace(/,?0+$/, "") + (saches * 37 >= 2000 ? __t("jogos_e_calculadoras.litros_de_concentrado_a_agua_entra_html", " litros de concentrado. A água entra só na hora de beber.") : __t("jogos_e_calculadoras.litro_de_concentrado_a_agua_entra_html", " litro de concentrado. A água entra só na hora de beber."));
    /* comparação em escala (02/10, ideia do cliente): sachês no meio, que se fecham em displays de 15 e na caixa de 60,
       e os cocos em volta, tudo no tamanho real */
    if ($("#escala")) escala(saches);
    $("#barraCoco").style.setProperty("--v", 1);
    $("#barraCaixinha").style.setProperty("--v", caixinha / coco);
    $("#barraSache").style.setProperty("--v", .03);
    /* sugestão de caixas: o menor conjunto de caixas com 60 e com 15 que cobre os sachês */
    var c60 = Math.floor(saches / 60), resto = saches - c60 * 60, c15 = 0;
    if (resto > 45) c60++; else c15 = Math.ceil(resto / 15);
    var partes = [];
    if (c60) partes.push(c60 + (c60 > 1 ? __t("jogos_e_calculadoras.caixas_com_60_saches_html", " caixas com 60 sachês") : __t("jogos_e_calculadoras.caixa_com_60_saches_html", " caixa com 60 sachês")));
    if (c15) partes.push(c15 + (c15 > 1 ? __t("jogos_e_calculadoras.displays_com_15_saches_html", " displays com 15 sachês") : __t("jogos_e_calculadoras.display_com_15_saches_html", " display com 15 sachês")));
    var caixas = c60 + c15;
    $("#caixaSugestao").innerHTML = __t("jogos_e_calculadoras.para_html", "Para ") + l + (l === 1 ? __t("jogos_e_calculadoras.litro_html", " litro") : __t("jogos_e_calculadoras.litros_html", " litros")) + ", " + partes.join(" e ") + (caixas > 1 ? __t("jogos_e_calculadoras.resolvem_html", " resolvem.") : __t("jogos_e_calculadoras.resolve_html", " resolve.")) +
      (caixas >= 2 ? __t("jogos_e_calculadoras.e_o_frete_sai_gratis_html", " E o frete sai grátis.") : "") + ' <a href="comprar.html?formato=' + (c60 ? "c60" : "c15") + '">' + (c60 ? __t("jogos_e_calculadoras.ver_a_caixa_html", "Ver a caixa") : __t("jogos_e_calculadoras.ver_o_display_html", "Ver o display")) + '</a>';
  }
  var COCOS_POR_SACHE = 25/15;   // número da IDCoco (display de 15 = 25 cocos); pendente de confirmação (o Matheus fala em 2)
  /* monte de cocos de diâmetro D numa cena de largura W: posições em grade hexagonal, mais alto no meio */
  function monte(D, W){
    var dx = D*.7, dy = dx*.87, pos = [];
    for (var r = 0; r < 60; r++) for (var k = -60; k <= 60; k++){
      var x = (k + (r % 2)/2)*dx, y = r*dy;
      if (Math.abs(x) > W/2 - D/2) continue;
      pos.push({ r: r, x: x, y: y, s: Math.abs(x) + y*1.15 });
    }
    pos.sort(function(p, q){ return p.s - q.s || p.r - q.r || p.x - q.x; });
    return pos;
  }
  /* sachês: caixas de 60, displays de 15 e soltos, com as medidas reais em cm */
  function itensSache(saches, cm){
    var caixas = Math.floor(saches/60), resto = saches - caixas*60, displays = Math.floor(resto/15), soltos = resto - displays*15;
    var itens = [], cxL = 38*cm*320/264, dpL = 30*cm;   // caixa 27 × 17 cm vista de quina: 38 cm de largura no desenho
    for (var a = 0; a < caixas; a++) itens.push({ c: "cx", w: cxL, h: cxL*260/320, html: '<svg viewBox="0 0 320 260"><use href="#caixa-60"/></svg>' });
    for (var b = 0; b < displays; b++) itens.push({ c: "dp", w: dpL, h: dpL*200/246, html: '<svg viewBox="0 0 246 200"><use href="#display-15"/></svg>' });
    for (var c = 0; c < soltos; c++) itens.push({ c: "sc", w: 5.74*cm*675/635, h: 14.04*cm*1600/1560, html: '<img src="' + window.__loja.assets + 'sache-plano-mini.webp" alt="">' });
    return { itens: itens, caixas: caixas, displays: displays, soltos: soltos };
  }
  /* altura que os sachês ocupam numa cena de largura Ws (linhas como no flex-wrap, gap de 3 px) */
  function alturaSaches(itens, Ws){
    var h = 0, linha = 0, hl = 0;
    itens.forEach(function(it){ if (linha && linha + 2 + it.w > Ws){ h += hl + 3; linha = 0; hl = 0; } linha += (linha ? 2 : 0) + it.w; hl = Math.max(hl, it.h); });
    return h + hl;
  }
  var escalaZoom = {};
  function escala(saches){
    var cena = $("#escala"), atras = $("#escalaCocos"), frente = $("#escalaFrente"), cenaS = $("#escalaSaches");
    var nCocos = Math.round(saches*COCOS_POR_SACHE);
    $("#pilhaCocoN").textContent = nCocos; $("#pilhaSacheN").textContent = saches;
    /* escala real (05/10): o corpo do coco ocupa 92 das 140 unidades do desenho e tem 20 cm; daí sai o cm em px, e
       sachê, display e caixa usam o mesmo cm. 07/10 (pedido do cliente): cocos e sachês em cenas separadas, lado a lado,
       num palco de altura fixa, e o zoom acompanha a quantidade: o maior coco com que o monte e os sachês ainda cabem
       no palco. Com poucos litros tudo aparece grande; com muitos, a "câmera se afasta". Os dois lados seguem na mesma escala. */
    var W = cena.clientWidth, H = cena.clientHeight - 6, Ws = cenaS.clientWidth, Hs = cenaS.clientHeight - 6;
    var chaveZ = nCocos + "|" + saches + "|" + W + "|" + H + "|" + Ws, D, posicoes;
    if (escalaZoom.chave === chaveZ){ D = escalaZoom.D; posicoes = escalaZoom.pos; }
    else {
      var cabe = function(d){
        var p = monte(d, W); if (p.length < nCocos) return null;
        var topo = 0; for (var i = 0; i < nCocos; i++) topo = Math.max(topo, p[i].y + d);
        if (topo > H) return null;
        if (alturaSaches(itensSache(saches, d*92/140/20).itens, Ws) > Hs) return null;
        return p;
      };
      var lo = 16, hi = Math.min(190, W/2.2), melhor = null;
      for (var it = 0; it < 14; it++){ var m = (lo + hi)/2, p = cabe(m); if (p){ lo = m; melhor = p; } else hi = m; }
      D = Math.floor(lo); posicoes = cabe(D) || melhor || monte(D, W);
      escalaZoom = { chave: chaveZ, D: D, pos: posicoes };
    }
    var cm = D*92/140/20, S = itensSache(saches, cm);
    /* mesma combinação de itens: só muda o tamanho (sem refazer, para não repetir a animação de entrada a cada passo) */
    var chave = S.caixas + "-" + S.displays + "-" + S.soltos;
    if (frente.dataset.chave !== chave){
      frente.innerHTML = S.itens.map(function(it){ return '<span class="' + it.c + '">' + it.html + '</span>'; }).join("");
      frente.dataset.chave = chave;
    }
    S.itens.forEach(function(it, i){ var el = frente.children[i]; el.style.width = it.w + "px"; el.style.height = it.h + "px"; });
    var cx = W/2;
    while (atras.children.length > nCocos) atras.removeChild(atras.lastChild);
    var antes = atras.children.length;
    for (var i = 0; i < nCocos; i++){
      var el = atras.children[i];
      if (!el){ el = document.createElement("span"); el.innerHTML = '<img src="' + window.__loja.assets + 'coco-calc.webp" alt="" width="280" height="260" decoding="async">';  /* foto do coco (08/10), calibrada no mesmo quadro 140x130 do desenho antigo */
        el.firstChild.style.animationDelay = Math.min(i - antes, 20)*18 + "ms"; atras.appendChild(el); }
      var q = posicoes[i];
      /* posição e tamanho por transform (06/10): left/bottom/width com transição recalculavam o layout de até 100 cocos
         a cada passo do controle e travavam no celular. O span tem 100 px e a escala vem no transform */
      var tr = "translate(" + (cx + q.x - D/2) + "px," + (-q.y) + "px) scale(" + (D/100) + ")";
      if (el.style.transform !== tr) el.style.transform = tr;
      el.style.zIndex = 100 - q.r;
    }
    var partes = [];
    if (S.caixas) partes.push(S.caixas + (S.caixas > 1 ? __t("jogos_e_calculadoras.caixas_de_60_html", " caixas de 60") : __t("jogos_e_calculadoras.caixa_de_60_html", " caixa de 60")));
    if (S.displays) partes.push(S.displays + (S.displays > 1 ? __t("jogos_e_calculadoras.displays_de_15_html", " displays de 15") : __t("jogos_e_calculadoras.display_de_15_html", " display de 15")));
    if (S.soltos) partes.push(S.soltos + (S.soltos > 1 ? " soltos" : " solto"));
    $("#pilhaPacote").textContent = partes.length ? "· " + partes.join(" + ") : "";
  }
  addEventListener("resize", function(){ if ($("#escala")) carregar(); });

  /* adiciona ou tira só a diferença, para cada item novo cair com animação e os antigos ficarem parados */
  function ajustarPilha(el, n, html){
    var atual = el.children.length;
    for (var i = atual; i < n; i++){ var d = document.createElement("span"); d.innerHTML = html; d.style.animationDelay = Math.min(i - atual, 12)*25 + "ms"; el.appendChild(d); }
    for (var j = atual; j > n; j--) el.removeChild(el.lastChild);
    el.classList.toggle("muitos", n > 40);
  }
  /* no máximo uma atualização por quadro enquanto o dedo arrasta o controle (06/10) */
  var pedidoLitros = 0;
  litros.addEventListener("input", function(){ if (!pedidoLitros) pedidoLitros = requestAnimationFrame(function(){ pedidoLitros = 0; carregar(); }); });
  carregar();
}

/* ---------- calculadora de hidratação: o corpo enche com os sachês do dia ---------- */
/* 06/10: treino até 4 h, intensidade e clima. Meta = 35 ml/kg + o suor do treino (taxa por hora conforme a intensidade,
   30% a mais em dia quente). O suor leva em média 900 mg de sódio e 200 mg de potássio por litro.
   SACHE = valores por sachê da tabela nutricional enviada pelo cliente em 13/10 (potássio 668 mg, 32% VD). */
var SACHE = { agua: 500, sodio: 45, potassio: 668 };
var SUOR = { leve: 500, moderada: 800, intensa: 1200 }, SUOR_SODIO = 900, SUOR_POTASSIO = 200;
var hPeso = $("#hPeso");
if (hPeso){
  var hTreino = $("#hTreino"), botoesS = $$(".cu-alavanca-botoes button"), botoesI = $$("[data-int]"), hQuente = $("#hQuente"),
      nivel = $("#hNivel"), onda = $("#hOnda"), saches = 2, intensidade = "moderada";
  var mg = function(v){ return Math.round(v).toLocaleString("pt-BR") + " mg"; };
  var emLitros = function(ml){ var l = ml/1000; return (l % 1 ? num(l, 1) : l) + (l === 1 ? __t("jogos_e_calculadoras.litro_html", " litro") : __t("jogos_e_calculadoras.litros_html", " litros")); };   // não "litros": var no mesmo arquivo sobrescrevia o controle da calculadora de litros (NaN em Curiosidades, 07/10)
  var curto = function(ml){ return ml >= 1000 || ml === 0 ? num(ml/1000, ml % 1000 ? 1 : 0) + " L" : Math.round(ml) + " ml"; };
  function hidratar(){
    var peso = +hPeso.value, treino = +hTreino.value, quente = hQuente.getAttribute("aria-pressed") === "true";
    var suor = treino * SUOR[intensidade] * (quente ? 1.3 : 1);
    var meta = peso*35 + suor, coco = saches*SACHE.agua, frac = Math.min(1, coco/meta);
    $("#hPesoValor").textContent = peso + " kg";
    $("#hTreinoValor").textContent = treino === 0 ? "nenhuma" : num(treino, treino % 1 ? 1 : 0) + (treino === 1 ? " hora" : " horas");
    $("#hMeta").textContent = num(meta/1000, 1) + " L";
    $("#hMl").textContent = coco >= 1000 ? emLitros(coco) : coco + " ml";
    $("#hPct").textContent = Math.round(frac*100) + "%";
    var topo = 470 - 455*frac;                         // o corpo vai de 15 (cabeça) a 470 (pés)
    nivel.setAttribute("y", topo); onda.setAttribute("transform", "translate(0," + (topo - 6) + ")");
    onda.style.opacity = frac > 0 && frac < 1 ? .8 : 0;
    var txt = saches === 0 ? __t("jogos_e_calculadoras.nenhum_sache_ainda_escolha_quantos_voce_html", "<b>Nenhum sachê ainda.</b> Escolha quantos você toma no dia.")
      : "<b>" + saches + (saches > 1 ? __t("jogos_e_calculadoras.saches_viram_html", " sachês viram ") : __t("jogos_e_calculadoras.sache_vira_html", " sachê vira ")) + (coco >= 1000 ? emLitros(coco) : coco + " ml") + __t("jogos_e_calculadoras.de_agua_de_coco_isso_e_html", " de água de coco.</b> Isso é ") + Math.round(frac*100) + __t("jogos_e_calculadoras.da_agua_estimada_para_o_seu_html", "% da água estimada para o seu dia.");
    if (treino > 0) txt += __t("jogos_e_calculadoras.no_treino_o_suor_leva_cerca_html", " No treino, o suor leva cerca de ") + curto(suor) + __t("jogos_e_calculadoras.de_agua_junto_com_sodio_e_html", " de água junto com sódio e potássio") + (saches ? __t("jogos_e_calculadoras.e_os_saches_devolvem_parte_desses_html", ", e os sachês devolvem parte desses sais.") : ".");
    else txt += __t("jogos_e_calculadoras.sem_treino_o_suor_leva_pouco_html", " Sem treino, o suor leva pouco sal; o resto da água vem do copo e da comida.");
    $("#hTexto").innerHTML = txt;
    $("#hSuor").textContent = curto(suor);
    $("#hAguaS").textContent = curto(coco);
    $("#hNaSai").textContent = mg(suor/1000*SUOR_SODIO);
    $("#hKSai").textContent = mg(suor/1000*SUOR_POTASSIO);
    $("#hNaVem").textContent = mg(saches*SACHE.sodio);
    $("#hKVem").textContent = mg(saches*SACHE.potassio);
    $("#hSaches").innerHTML = new Array(saches + 1).join('<img src="' + window.__loja.assets + 'sache-plano-mini.webp" alt="">');
    hPeso.style.setProperty("--p", ((peso - 40)/90*100) + "%");
    hTreino.style.setProperty("--p", (treino/4*100) + "%");
  }
  botoesS.forEach(function(b){ b.addEventListener("click", function(){
    saches = +b.dataset.s;
    botoesS.forEach(function(x){ x.setAttribute("aria-checked", x === b ? "true" : "false"); });
    hidratar();
  }); });
  botoesI.forEach(function(b){ b.addEventListener("click", function(){
    intensidade = b.dataset.int;
    botoesI.forEach(function(x){ x.setAttribute("aria-checked", x === b ? "true" : "false"); });
    hidratar();
  }); });
  hQuente.addEventListener("click", function(){ hQuente.setAttribute("aria-pressed", hQuente.getAttribute("aria-pressed") === "true" ? "false" : "true"); hidratar(); });
  hPeso.addEventListener("input", hidratar); hTreino.addEventListener("input", hidratar);
  hidratar();
}

/* ---------- desafio da hidratação ---------- */
/* Um dia de 40 s em cinco cenas. Cada cena tira água e sais por segundo (em pontos de 0 a 100). Água: +16 de água e
   -4 de sais (dilui). IDCoco: +14 de água e +20 de sais, com 2,5 s de espera entre um sachê e outro.
   Faixa verde de 40 a 85 nas duas barras; o placar é a fração do tempo com as duas dentro. */
var jogo = $("#cuJogo");
if (jogo){
  var CENAS = [
    { ate: 7,  hora: [7, 9],   nome: __t("jogos_e_calculadoras.cafe_da_manha_html", "Café da manhã"),      agua: 1.2, sais: .5, ceu: ["#f6e6d0", "#fefaf5"], suor: "" },
    { ate: 15, hora: [9, 12],  nome: __t("jogos_e_calculadoras.trabalho_html", "Trabalho"),           agua: 1.6, sais: .6, ceu: ["#e3eef2", "#fefaf5"], suor: "" },
    { ate: 24, hora: [12, 15], nome: __t("jogos_e_calculadoras.sol_do_meio_dia_html", "Sol do meio-dia"),    agua: 3.2, sais: 1.6, ceu: ["#cfe6f0", "#fff6e0"], suor: "alto" },
    { ate: 33, hora: [15, 18], nome: __t("jogos_e_calculadoras.treino_html", "Treino"),             agua: 4.2, sais: 3.6, ceu: ["#f3d9b8", "#fdf0e0"], suor: "alto" },
    { ate: 40, hora: [18, 22], nome: __t("jogos_e_calculadoras.fim_de_tarde_quente_html", "Fim de tarde quente"), agua: 2.4, sais: 1.2, ceu: ["#e9c9b3", "#f6e9e0"], suor: "" }
  ];
  var DUR = 40, MIN = 40, MAX = 85;
  var el = { hora: $("#jgHora"), cena: $("#jgCena"), pontos: $("#jgPontos"), dia: $("#jgDia"), agua: $("#jgAgua"), sais: $("#jgSais"),
    nivel: $("#jgNivel"), aviso: $("#jgAviso"), status: $("#jgStatus"), bAgua: $("#jgBtnAgua"), bCoco: $("#jgBtnCoco"),
    capa: $("#jgCapa"), titulo: $("#jgTitulo"), texto: $("#jgTexto"), comecar: $("#jgComecar"), ceu: $(".cu-jogo-ceu"), sol: $(".cu-jogo-sol"),
    barraA: $('.cu-jogo-barra[data-barra="agua"]'), barraS: $('.cu-jogo-barra[data-barra="sais"]') };
  var st, raf = 0, ultimo = 0, cenaAtual = -1, avisoAte = 0, visivel = true;
  function zerar(){ st = { t: 0, agua: 66, sais: 62, dentro: 0, esperaCoco: 0, so_agua: 0, cocos: 0, copos: 0 }; cenaAtual = -1; }
  function cenaDe(t){ for (var i = 0; i < CENAS.length; i++) if (t < CENAS[i].ate) return i; return CENAS.length - 1; }
  function avisar(txt){ el.aviso.textContent = txt; el.aviso.classList.add("ver"); avisoAte = st.t + 2.2; }
  function desenhar(){
    var i = cenaDe(st.t), c = CENAS[i], ini = i ? CENAS[i - 1].ate : 0, f = (st.t - ini)/(c.ate - ini);
    var h = c.hora[0] + (c.hora[1] - c.hora[0])*f, hh = Math.floor(h), mm = Math.floor((h - hh)*60/15)*15;
    el.hora.textContent = (hh < 10 ? "0" : "") + hh + ":" + (mm < 10 ? "0" : "") + mm;
    if (i !== cenaAtual){
      cenaAtual = i; el.cena.textContent = c.nome; jogo.dataset.suor = c.suor;
      el.ceu.style.setProperty("--ceu-1", c.ceu[0]); el.ceu.style.setProperty("--ceu-2", c.ceu[1]);
      if (st.t > 0) el.status.textContent = c.nome;
    }
    var p = st.t/DUR;
    el.dia.style.width = (p*100) + "%";
    el.sol.style.left = (6 + p*82) + "%"; el.sol.style.top = (40 - Math.sin(p*Math.PI)*32) + "%";
    el.agua.style.height = st.agua + "%"; el.sais.style.height = st.sais + "%";
    el.nivel.setAttribute("y", 470 - 455*st.agua/100);
    el.barraA.classList.toggle("fora", st.agua < MIN || st.agua > MAX);
    el.barraS.classList.toggle("fora", st.sais < MIN || st.sais > MAX);
    el.pontos.textContent = Math.round(st.t ? st.dentro/st.t*100 : 0) + "%";
    el.bCoco.classList.toggle("espera", st.esperaCoco > 0);
    if (avisoAte && st.t > avisoAte){ el.aviso.classList.remove("ver"); avisoAte = 0; }
  }
  function passo(agora){
    raf = 0;
    if (!visivel){ ultimo = 0; raf = requestAnimationFrame(passo); return; }   // fora da tela o tempo do jogo para
    var dt = ultimo ? Math.min(.1, (agora - ultimo)/1000) : 0; ultimo = agora;
    var c = CENAS[cenaDe(st.t)];
    st.t = Math.min(DUR, st.t + dt);
    st.agua = Math.max(0, st.agua - c.agua*dt); st.sais = Math.max(0, st.sais - c.sais*dt);
    st.esperaCoco = Math.max(0, st.esperaCoco - dt);
    if (st.agua >= MIN && st.agua <= MAX && st.sais >= MIN && st.sais <= MAX) st.dentro += dt;
    if (!avisoAte){
      if (st.agua < 30) avisar(__t("jogos_e_calculadoras.sede_hora_de_beber_html", "Sede! Hora de beber"));
      else if (st.sais < 30) avisar(__t("jogos_e_calculadoras.faltam_sais_minerais_html", "Faltam sais minerais"));
    }
    desenhar();
    if (st.t >= DUR) return fim();
    raf = requestAnimationFrame(passo);
  }
  function beber(tipo){
    if (jogo.dataset.estado !== "jogando") return;
    if (tipo === "coco"){
      if (st.esperaCoco > 0) return avisar(__t("jogos_e_calculadoras.calma_um_sache_de_cada_vez_html", "Calma, um sachê de cada vez"));
      st.agua = Math.min(100, st.agua + 14); st.sais = Math.min(100, st.sais + 20); st.esperaCoco = 2.5; st.cocos++;
    } else {
      st.agua = Math.min(100, st.agua + 16); st.sais = Math.max(0, st.sais - 4); st.copos++;
      if (st.sais < 45 && st.copos % 3 === 0) avisar(__t("jogos_e_calculadoras.so_agua_dilui_os_sais_html", "Só água dilui os sais"));
    }
    if (st.agua > 92) avisar(__t("jogos_e_calculadoras.agua_demais_de_uma_vez_html", "Água demais de uma vez"));
    desenhar();
  }
  function comecar(){
    zerar(); jogo.dataset.estado = "jogando"; el.bAgua.disabled = el.bCoco.disabled = false;
    ultimo = 0; el.status.textContent = __t("jogos_e_calculadoras.o_dia_comecou_html", "O dia começou: ") + CENAS[0].nome; desenhar();
    if (!raf) raf = requestAnimationFrame(passo);
    el.bCoco.focus({ preventScroll: true });
  }
  function fim(){
    jogo.dataset.estado = "fim"; jogo.dataset.suor = ""; el.bAgua.disabled = el.bCoco.disabled = true;
    var pct = Math.round(st.dentro/DUR*100), titulo, texto;
    if (pct >= 80){ titulo = pct + __t("jogos_e_calculadoras.do_dia_no_verde_hidratacao_de_html", "% do dia no verde. Hidratação de atleta!"); texto = __t("jogos_e_calculadoras.voce_equilibrou_agua_e_sais_o_html", "Você equilibrou água e sais o dia todo. É assim que funciona: no calor e no treino, o suor leva os dois, e a água de coco devolve os dois de uma vez."); }
    else if (pct >= 50){ titulo = pct + __t("jogos_e_calculadoras.do_dia_no_verde_quase_la_html", "% do dia no verde. Quase lá!"); texto = st.cocos < 3 ? __t("jogos_e_calculadoras.faltou_sal_na_conta_quando_o_html", "Faltou sal na conta. Quando o suor aperta, só água não repõe o sódio e o potássio que vão embora. Experimente usar o IDCoco no sol e no treino.") : __t("jogos_e_calculadoras.faltou_ritmo_beber_aos_poucos_funciona_html", "Faltou ritmo. Beber aos poucos funciona melhor do que esperar a sede e tomar tudo de uma vez."); }
    else { titulo = pct + __t("jogos_e_calculadoras.do_dia_no_verde_o_dia_html", "% do dia no verde. O dia ganhou de você."); texto = __t("jogos_e_calculadoras.a_sede_chega_depois_que_o_html", "A sede chega depois que o corpo já perdeu água. Beba antes do treino e do sol forte, e lembre que o suor leva sais minerais junto."); }
    el.titulo.textContent = titulo; el.texto.textContent = texto; el.comecar.textContent = __t("curiosidades.jogar_de_novo_html", "Jogar de novo");
    el.status.textContent = titulo;
    el.comecar.focus({ preventScroll: true });
  }
  el.comecar.addEventListener("click", comecar);
  el.bAgua.addEventListener("click", function(){ beber("agua"); });
  el.bCoco.addEventListener("click", function(){ beber("coco"); });
  /* pausa fora da tela ou com a aba escondida, e retoma de onde parou */
  function retomar(){ if (visivel && jogo.dataset.estado === "jogando" && !raf){ ultimo = 0; raf = requestAnimationFrame(passo); } }
  if ("IntersectionObserver" in window) new IntersectionObserver(function(e){ visivel = e[0].isIntersecting && !document.hidden; retomar(); }, { threshold: .25 }).observe(jogo);
  document.addEventListener("visibilitychange", function(){ visivel = !document.hidden; retomar(); });
  zerar(); desenhar();
}

/* ---------- o coco na Segunda Guerra: abas ---------- */
var gAbas = $$(".cu-guerra-abas [role=tab]"), gCena = $("#gCena");
function abaGuerra(b, foco){
  gAbas.forEach(function(x){ var sel = x === b; x.setAttribute("aria-selected", sel ? "true" : "false"); x.tabIndex = sel ? 0 : -1; $("#" + x.getAttribute("aria-controls")).hidden = !sel; });
  if (gCena) gCena.dataset.g = b.dataset.g;
  if (foco) b.focus();
}
gAbas.forEach(function(b, i){
  b.addEventListener("click", function(){ abaGuerra(b); });
  b.addEventListener("keydown", function(e){
    var d = e.key === "ArrowRight" ? 1 : e.key === "ArrowLeft" ? -1 : 0;
    if (d){ e.preventDefault(); abaGuerra(gAbas[(i + d + gAbas.length) % gAbas.length], true); }
  });
});

/* ---------- sabia que ---------- */
var SABIA = [
  __t("jogos_e_calculadoras.o_nome_coco_vem_de_uma_html", "O nome coco vem de uma palavra portuguesa para careta. Os três furinhos da casca lembram um rosto."),
  __t("jogos_e_calculadoras.o_nome_cientifico_do_coqueiro_e_html", "O nome científico do coqueiro é Cocos nucifera."),
  __t("jogos_e_calculadoras.um_coqueiro_nao_tem_safra_da_html", "Um coqueiro não tem safra: dá coco o ano inteiro, com cachos novos surgindo ao longo dos meses."),
  __t("jogos_e_calculadoras.conforme_o_coco_amadurece_parte_da_html", "Conforme o coco amadurece, parte da água vira polpa. O verde tem mais água; o seco, mais carne."),
  __t("jogos_e_calculadoras.um_sache_de_37_ml_vira_html", "Um sachê de 37 ml vira até 500 ml de água de coco. É meio litro que cabe no bolso."),
  __t("jogos_e_calculadoras.foram_mais_de_20_anos_de_html", "Foram mais de 20 anos de pesquisa até chegar ao processo que concentra a água de coco verde."),
  __t("jogos_e_calculadoras.no_aterro_a_casca_do_coco_html", "No aterro, a casca do coco verde levaria de 12 a 20 anos para se decompor. Na IDCoco, ela vira energia."),
  __t("jogos_e_calculadoras.pelo_calculo_da_fabrica_cada_24_html", "Pelo cálculo da fábrica, cada 24 toneladas de sachês tiram 110 caminhões de coco das estradas."),
  __t("jogos_e_calculadoras.fechado_o_sache_dura_12_meses_html", "Fechado, o sachê dura 12 meses sem geladeira.")
];
var sabiaTexto = $("#sabiaTexto");
if (sabiaTexto){
  var s = Math.floor(Math.random() * SABIA.length);
  function sabia(){
    sabiaTexto.classList.remove("entra"); void sabiaTexto.offsetWidth; sabiaTexto.classList.add("entra");
    sabiaTexto.textContent = SABIA[s];
    $("#sabiaConta").textContent = (s + 1) + " de " + SABIA.length;
  }
  $("#sabiaOutra").addEventListener("click", function(){ s = (s + 1) % SABIA.length; sabia(); });
  sabia();
}
})();
